const searchFocusableElements = ['input' , 'button' , '[href]', 'select', 'textarea', '[tabindex]:not([tabindex="-1"])'];
let siteSearch = document.querySelector('.search-container');
let firstFocusableSearchElement = siteSearch.querySelectorAll(searchFocusableElements)[0];
let focusableSearchContent =  siteSearch.querySelectorAll(searchFocusableElements);
let lastFocusableSearchElement = focusableSearchContent[focusableSearchContent.length - 1];
var openSiteSearchInitiator;

const openSiteSearch = (e) => {
    openSiteSearchInitiator = e.currentTarget;
    let siteSearch = document.querySelector('.search-container');
    let docBody = document.body;
    siteSearch.classList.add('is-open');
    docBody.classList.add('overflow-hidden');
    let firstfocusableElement = siteSearch.querySelector('.close-search');
    firstfocusableElement.focus()
}

const closeSiteSearch = (e) => {
    let siteSearch = document.querySelector('.search-container');
    let docBody = document.body;
    siteSearch.classList.remove('is-open');
    docBody.classList.remove('overflow-hidden');
    openSiteSearchInitiator.focus();
}

let searchBg = document.querySelector('.search-bg');
if (typeof(searchBg) != 'undefined' && searchBg != null) {
    searchBg.addEventListener('click', closeSiteSearch, false);
}

let closeSearchButton = document.querySelector('.close-search');
if (typeof(closeSearchButton) != 'undefined' && closeSearchButton != null) {
    closeSearchButton.addEventListener('click', closeSiteSearch, false);
}

let openSearchButtons = document.querySelectorAll('.open-site-search');
for (var i = 0, l = openSearchButtons.length; i < l; i++) {
    openSearchButtons[i].addEventListener('click', closeMainMenu, false);
    openSearchButtons[i].addEventListener('click', openSiteSearch, false);
}

document.addEventListener('keydown', function(e) {
    if(siteSearch.classList.contains('is-open')){
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        let isEscPressed = e.key === 'Escape' || e.keyCode === 27;

        if(isEscPressed){
            closeSiteSearch();
        }
        
        if (!isTabPressed) {
            return;
        }
        
        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableSearchElement) {
                lastFocusableSearchElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === lastFocusableSearchElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableSearchElement.focus(); // add focus for the first focusable element
            e.preventDefault();
            }
        }
    }
});